<template>
  <component
    :is="as"
    :class="['pill', { active, readonly, 'no-margin': noMargin, sortable, empty }]"
    v-tooltip="{ content: tooltip, delay: { show: 1000, hide: 100 }, placement: 'bottom' }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span>
      <slot />
    </span>

    <icon v-if="sortable" name="arrow_drop_down" class="icon" />
  </component>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    as: {
      type: String,
      default: 'button',
    },
    active: Boolean,
    readonly: Boolean,
    tooltip: String,
    noMargin: Boolean,
    sortable: Boolean,
    empty: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.pill {
  @include ellipsis;
  appearance: none;
  border: none;
  color: inherit;
  background-color: var(--theme-pill);
  border-radius: 20px;
  height: 28px;
  margin: var(--pill-margin, 0 $gp * .25 $gp * .5 0);
  font-size: 14px;
  padding: 0 $gp * .5;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 300px;
  text-decoration: none !important;

  > span {
    @include ellipsis;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &.empty > span {
    opacity: 0.5;
  }

  &.no-margin {
    margin: 0;
  }

  &.sortable {
    margin: 0;
    padding: 0 $gp * .25 0 13.33px;

    .icon {
      margin-left: $gp * .25;
    }
  }

  &.active {
    background-color: $color-green-1;
    color: $color-white;
  }

  &.readonly {
    cursor: default;
  }

  &:not(.active):not(.readonly) {
    &:hover,
    &:focus {
      background-color: var(--theme-pill-hover);
    }
  }
}
</style>
